import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import { I18nProvider } from "./i18n";
import { Spinner } from "./components/ui";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Legal from "./pages/Legal";
import QRAccess from "./pages/QRAccess";
import Dashboard from "./pages/staff/Dashboard";
import Patients from "./pages/staff/Patients";
import PatientDetail from "./pages/staff/PatientDetail";
import Exercises from "./pages/staff/Exercises";
import Programs from "./pages/staff/Programs";
import Messages from "./pages/staff/Messages";
import HillDT from "./pages/staff/HillDT";
import { ClinicsPage, UsersPage, AuditPage } from "./pages/staff/Admin";
import Portal from "./pages/portal/Portal";

function Loading() {
  return <div className="min-h-screen flex items-center justify-center bg-vlg"><Spinner className="h-8 w-8" /></div>;
}

function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <Loading />;
  if (!user) return <Navigate to="/connexion" replace />;
  if (user.role === "patient" && (!roles || !roles.includes("patient"))) return <Navigate to="/portail" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/connexion" element={<Login />} />
      <Route path="/confidentialite" element={<Legal type="privacy" />} />
      <Route path="/conditions" element={<Legal type="terms" />} />
      <Route path="/acces" element={<QRAccess />} />

      <Route path="/portail" element={<Protected roles={["patient"]}><Portal /></Protected>} />

      <Route path="/app" element={<Protected roles={["superadmin", "clinic_admin", "professional", "assistant"]}><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="patients" element={<Patients />} />
        <Route path="patients/:id" element={<PatientDetail />} />
        <Route path="exercices" element={<Exercises />} />
        <Route path="programmes" element={<Programs />} />
        <Route path="messagerie" element={<Messages />} />
        <Route path="hilldt" element={<HillDT />} />
        <Route path="cabinets" element={<ClinicsPage />} />
        <Route path="utilisateurs" element={<UsersPage />} />
        <Route path="audit" element={<AuditPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
